import { collect, memo } from '@morphic-ts/common/es6/utils';
import * as t from 'io-ts';
import { iotsApplyConfig } from '../config';
import { IOTSType, IoTsURI } from '../hkt';
const coerce = (arr) => arr;
/**
 *  @since 0.0.1
 */
export const ioTsTaggedUnionInterpreter = memo(() => ({
    _F: IoTsURI,
    taggedUnion: (_tag, dic, name, config) => env => new IOTSType(iotsApplyConfig(config)(t.union(coerce(collect(dic, (_, getType) => getType(env).type)), name), env, {}))
}));
